import styled from '@emotion/styled';

const DropdownWrapper = styled('div')({
  position: 'absolute',
  right: 0,
  top: 0,
});

export default DropdownWrapper;
